import { render, staticRenderFns } from "./NewsBannerCreate .vue?vue&type=template&id=8c3b5abe&scoped=true&"
import script from "./NewsBannerCreate .vue?vue&type=script&lang=js&"
export * from "./NewsBannerCreate .vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c3b5abe",
  null
  
)

export default component.exports